import {
  THEME_COLOR_NAMES,
  THEME_COLOR_SHADE_NAMES,
  THEME_COLOR_TYPE_NAMES,
} from '../enums/colors';

const shades = Object.values(THEME_COLOR_SHADE_NAMES);
/**
 * @name createColors
 * @description auxiliary
 * @param  {string[]} values
 * @returns {any}
 */
function createColors(...values) {
  return values.reduce(
    (acc, color, i) => ({
      ...acc,
      [values.length > shades.length ? i + 1 : shades[i]]: color,
    }),
    {}
  );
}

/**
 * @name THEME_COLORS
 * @description default colors
 */
export const THEME_COLORS = {
  [THEME_COLOR_NAMES.COMMON]: {
    [THEME_COLOR_TYPE_NAMES.BRAND]: '#019DF4',
    [THEME_COLOR_TYPE_NAMES.BLACK]: '#0B2739',
    [THEME_COLOR_TYPE_NAMES.WHITE]: '#FFFFFF',
  },
  [THEME_COLOR_TYPE_NAMES.BLACK]: createColors('#0B2739'),
  [THEME_COLOR_TYPE_NAMES.WHITE]: createColors('#FFFFFF'),
  [THEME_COLOR_NAMES.PRIMARY]: createColors('#019DF4'),
  [THEME_COLOR_NAMES.SECONDARY]: createColors('#499010', '#BDE4A4', '#3C7521'),
  [THEME_COLOR_NAMES.GREY]: createColors(
    '#F5F5F5',
    '#D3D4D3',
    '#B6B7B7',
    '#86888C',
    '#50535A',
    '#313235'
  ),
  [THEME_COLOR_NAMES.PURPLE]: createColors('#A13EA1', '#DEBCE4', '#642A72'),
  [THEME_COLOR_NAMES.MAGENTA]: createColors('#E63780', '#FBC7DE', '#922859'),
  [THEME_COLOR_NAMES.ORANGE]: createColors('#EC624B', '#F8CCCC', '#983230'),
  [THEME_COLOR_NAMES.YELLOW]: createColors('#F28D15', '#F8D2B3', '#9F591F'),
};
